var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/24px/Log out"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 17.3409H4.16667C3.72464 17.3409 3.30072 17.1669 2.98816 16.8572C2.67559 16.5475 2.5 16.1274 2.5 15.6894V4.12878C2.5 3.69077 2.67559 3.2707 2.98816 2.96098C3.30072 2.65126 3.72464 2.47726 4.16667 2.47726H7.5",
    stroke: "#178477",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.3333 14.0379L17.5 9.90909L13.3333 5.7803",
    stroke: "#178477",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.5 9.90909H7.5",
    stroke: "#178477",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.27a4bd2c58fc392ff477a9798872767d.svg";
export { ForwardRef as ReactComponent };